import { Mapper } from "../../../../base/utils/mapper";
import { TypeIncomeModel } from "../../../../domain/models/consult/type-income.model";
import { TypeIncomeEntity } from "../entities/type-income.entity";


export class TypeIncomeImplementationRepositoryMapper extends Mapper<TypeIncomeEntity, TypeIncomeModel> {
    mapFrom(param: TypeIncomeEntity): TypeIncomeModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeIncomeModel): TypeIncomeEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}